// Export the Component Definition for use in Contentful Studio
export {
  TextCollectionContentfulComponentDefinition,
  textCollectionColumnsDefinition,
} from './TextCollectionContentfulDefinition';
export {default} from './TextCollection';
export type {
  TextCollectionColumns,
  TextCollectionProps,
} from './TextCollection';
